import { Appointment } from "../modals/Appointment";
import IBSService from "./IBSService";
import { Mixpanel } from "./MixPanel";

const taskListId: string = "c96b91ab-7662-4533-8172-5e1e387ea918";

const ibsService = new IBSService();

export const deleteBookingTask = async (estimateId: string) => {
  try {
    const tasks: Appointment[] = (
      await (await ibsService.getTasksForUser(taskListId)).json()
    ).Data;
    const bookingTask = tasks.filter(
      (x) =>
        x.assignments.filter((y) => y.assignedToId === estimateId).length > 0
    )[0];
    if (bookingTask) {
      const response = await ibsService.deleteTask(bookingTask.id);
      if (response.ok) {
        Mixpanel.track("Booking Task Deleted", {
          bookingTask,
          bookingTaskId: bookingTask.id,
          estimateId: estimateId,
          status: "Booking Task Deleted successfully"
        });
      } else {
        const resp = await response.json();
        Mixpanel.track("Booking Task Delete Error", {
          bookingTask,
          bookingTaskId: bookingTask.id,
          estimateId: estimateId,
          error: resp.errors,
          status: "Booking task not deleted"
        });
      }
    }
  } catch (err) {
    Mixpanel.track("Booking Task Delete Error", {
      estimateId: estimateId,
      exceptionError: err,
      status: "Booking task not deleted"
    });
    throw new Error("Data could not be fetched!");
  }
};
